<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import axios from "axios";

export default {
    name: "StrBalanceAutocomplete",
    props: {
        value: Number,
        data: Array,
        rules: Array,
        readonly: Boolean,
        label: String,
    },
    setup(props) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const balance = ref(null);
        const balances = ref([]);


        function findAll() {
            loading.value = true;
            axios.get('/balances', { params: {allRecords: true}}).then(response => {
                balances.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        watch(() => props.value, () => {
            balance.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            loading,
            inputColor,
            backgroundColor,
            balance,
            balances,
        }
    },
};
</script>

<template>
    <div>
        <v-autocomplete
                v-model="balance"
                :label="label"
                :items="balances"
                item-value="id"
                item-text="name"
                outlined
                dense
                clearable
                :readonly="readonly"
                :loading="loading"
                :color="inputColor"
                :background-color="backgroundColor"
                hide-details="auto"
                @input="$emit('input', balance)"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>